import { initPublicHeader } from './header';

function initAOS() {
    if (!document.querySelector('[data-aos]')) {
        return;
    }

    const loadAOS = async () => {
        await import('aos/dist/aos.css');

        const AOS = (await import('aos')).default;
        AOS.init();
        window.addEventListener('load', AOS.refresh);
    };

    loadAOS();
}

document.addEventListener('DOMContentLoaded', () => {
    initPublicHeader();
    initAOS();
});
